module.exports = __webpack_public_path__ + "static/media/water-fall.2ab23cdc.svg";